import { render, staticRenderFns } from "./OrangeList.vue?vue&type=template&id=9d0d4c2e&"
import script from "./OrangeList.vue?vue&type=script&lang=js&"
export * from "./OrangeList.vue?vue&type=script&lang=js&"
import style0 from "./OrangeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports